import { ElementBaseQuickSettingRect, IQuickSettingRect } from './base';
import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';

export class GroupQuickSettingRect extends ElementBaseQuickSettingRect {
    private groupModel: IGroupModel;
    public constructor(model: IGroupModel) {
        super(model);
        this.groupModel = model;
    }

    public getQuickSettingRect(scale: number): IQuickSettingRect {
        const rect = super.getQuickSettingRect(scale);
        const groupRect = ElementBaseQuickSettingRect.modifyGroupRect({ ...rect, left: rect.x, top: rect.y }, scale);
        return { ...groupRect, x: groupRect.left, y: groupRect.top };
    }
}
